var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ContentWrapper",
    [
      _c("div", { staticClass: "content-heading" }, [
        _c("div", [_vm._v(_vm._s(_vm.page.title))]),
        _c("ol", { staticClass: "breadcrumb ml-auto" }, [
          _c("li", { staticClass: "breadcrumb-item" }, [
            _c("a", { attrs: { href: "#" } }, [_vm._v("Home")])
          ]),
          _c("li", { staticClass: "breadcrumb-item" }, [
            _vm._v("\n          콘텐츠 관리\n        ")
          ]),
          _c("li", { staticClass: "breadcrumb-item active" }, [
            _c("a", { attrs: { href: _vm.page.prevUrl } }, [
              _vm._v(_vm._s(_vm.page.prevTitle))
            ])
          ])
        ])
      ]),
      _c("contentsEditInfo", {
        attrs: { type: _vm.type, bookSeq: _vm.bookSeq }
      }),
      _c("contentsDepth", {
        attrs: { orgContSeq: _vm.info.orgContSeq, contSeq: _vm.info.contSeq }
      }),
      _c("loading", {
        attrs: { active: _vm.modalLoading, "is-full-page": true }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }